export default {
	profile: {
		tabs: { perfil: 'Perfil', info: 'Información', security: 'Seguridad' },
		themeLight: 'Tema claro',
		language: 'Idioma',
		logout: 'Cerrar sesión',
		save: 'Guardar',
		emails: 'Correos',
		phones: 'Teléfonos',
		addEmail: '+ Agregar correo',
		addPhone: '+ Agregar teléfono',
		currentPassword: 'Contraseña actual',
		newPassword: 'Nueva contraseña',
		confirmPassword: 'Confirmar nueva contraseña',
		changePassword: 'Cambiar contraseña',
		cancel: 'Cancelar',
		fillAllFields: 'Completar todos los campos',
		passwordMismatch: 'Las contraseñas nuevas no coinciden',
		photoUpdated: 'Foto actualizada',
		photoError: 'Error al subir la foto',
		infoUpdated: 'Información actualizada',
		infoError: 'Error al actualizar información',
		passwordUpdated: 'Contraseña actualizada',
		passwordError: 'Error al cambiar contraseña',
		themeError: 'Error al cambiar el tema',
		languageUpdated: 'Idioma actualizado',
		languageError: 'Error al cambiar el idioma',
		name: 'Nombre',
	},
};
